import { ZoomIn, ZoomOut } from "../ui/icons";
import { FloatingIconButton } from "../ui/floating-icon-button";
import { useMap } from "react-leaflet";
import { ButtonGroup } from "../ui/button-group";

export default function ZoomControl() {
  const map = useMap();

  function handleZoomIn() {
    map.zoomIn();
  }

  function handleZoomOut() {
    map.zoomOut();
  }

  const buttons = [
    {
      icon: <ZoomIn />,
      onClick: handleZoomIn,
      ariaLabel: "Zoom In",
      tooltip: "Aproximar",
    },
    {
      icon: <ZoomOut />,
      onClick: handleZoomOut,
      ariaLabel: "Zoom Out",
      tooltip: "Distanciar",
    },
  ];

  return (
    <ButtonGroup orientation="vertical">
      {buttons.map((button, index) => (
        <FloatingIconButton
          key={index}
          onClick={button.onClick}
          aria-label={button.ariaLabel}
          title={button.tooltip}
          size="sm"
        >
          {button.icon}
        </FloatingIconButton>
      ))}
    </ButtonGroup>
  );
}
